<div class="main">
  @if (newlySharedProjects().length > 0) {
    <div>{{ 'Nytt:' | uppercase }}</div>
  }
  @for (newlySharedProject of newlySharedProjects(); track $index) {
    <button
      cdkOverlayOrigin
      #newShareProjectOrigin="cdkOverlayOrigin"
      (click)="selectNewlySharedProject(newlySharedProject.id)"
      class="shared-project-button"
      matButton="filled"
      matBadge="!"
    >
      <mat-icon>{{ newlySharedProject.ownerId === userService.user().id ? 'business_center' : 'share' }}</mat-icon>
      <strong>{{ newlySharedProject.ownerName }}</strong>{{ ` har delat projektet "${newlySharedProject.projectName}" med dig.` }}
    </button>

    @if ($index === 0) {
      <smt-tutorials
        [style.margin-top.px]="-20"
        [objectId]="newShareProjectOrigin"
        tutorialId="newShareProject"
        tutorialText="Ett nytt projekt att samla in samtycke till!"
      />
    }
  }

  @if (!userService.user().firstTimeLogin) {
    <div>{{ 'Senaste projekt:' | uppercase }}</div>

    <mat-card appearance="filled">
      <mat-card-content>
        <smt-project-buttons
          [userId]="userService.user().id"
          [projects]="latestProjects()"
        />
      </mat-card-content>
    </mat-card>
  }

  @if (userService.user().firstTimeLogin) {
    <mat-card class="private" appearance="filled">
      <mat-card-content>
        <div class="first-time-text">
          <h2>
            Hej{{ userService.user().name ? ` ${userService.user().name | firstName}` : '' }}!
          </h2>

          <div class="talking">
            Välkommen till Bildsamtycke.
          </div>

          <div class="talking">
            Platsen där Bildsamtycke skapas och samlas in.
          </div>

          <div>
            Vill du veta mer om tjänsten?<br>
            <a href="https://bildsamtycke.se" target="_blank">Klicka här!</a>
          </div>

        </div>

      </mat-card-content>
    </mat-card>
  }

  @if (userService.adminUser()) {
    <div class="quick-start-holder">
      <div class="quick-start-container">
        <button
          cdkOverlayOrigin
          #quickStartOrigin="cdkOverlayOrigin"
          (click)="quickStart()"
          matFab
          class="quick-start-button">
          <mat-icon>electric_bolt</mat-icon>
          <div [style.margin-bottom.px]="10">Snabbstart</div>
        </button>

        <smt-tutorials
          [objectId]="quickStartOrigin"
          tutorialId="quickStart"
          tutorialText="Använd Snabbstart om du snabbt vill samla in bildsamtycke!"
        />

      </div>
    </div>
  }

  @if (!userService.adminUser()) {
    <div class="image-container">
      <img src="best-friend.png" alt="Bästa vän">
      <div class="text-overlay">
        <h3>
          "Bildsamtycke är <br>
          fotografen och<br>
          administratörens<br>
          bästa vän"
        </h3>
        <div>- Kommunanställd -</div>
      </div>
    </div>
  }
</div>
